/**
 * @generated SignedSource<<4eafc5bf0dbf7a9023a115a583fb3c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HistoryCondition = {
  accomplishedBy?: string | null;
  articleId?: string | null;
  authorGuid?: string | null;
  boardId?: string | null;
  createdAt?: string | null;
  data?: any | null;
  rowId?: number | null;
};
export type HistoryTimelineContainerPaginationQuery$variables = {
  condition?: HistoryCondition | null;
  count: number;
  cursor?: any | null;
};
export type HistoryTimelineContainerPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HistoryTimelineContainer_query">;
};
export type HistoryTimelineContainerPaginationQuery = {
  response: HistoryTimelineContainerPaginationQuery$data;
  variables: HistoryTimelineContainerPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "condition"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "condition",
    "variableName": "condition"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "CREATED_AT_DESC"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HistoryTimelineContainerPaginationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HistoryTimelineContainer_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HistoryTimelineContainerPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HistoriesConnection",
        "kind": "LinkedField",
        "name": "allHistories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HistoriesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rowId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "data",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authorByAccomplishedBy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "condition",
          "orderBy"
        ],
        "handle": "connection",
        "key": "HistoryTimelineContainer_allHistories",
        "kind": "LinkedHandle",
        "name": "allHistories"
      }
    ]
  },
  "params": {
    "cacheID": "43986a6a63ea35e7a17853fc5e76e4b1",
    "id": null,
    "metadata": {},
    "name": "HistoryTimelineContainerPaginationQuery",
    "operationKind": "query",
    "text": "query HistoryTimelineContainerPaginationQuery(\n  $condition: HistoryCondition\n  $count: Int!\n  $cursor: Cursor\n) {\n  ...HistoryTimelineContainer_query\n}\n\nfragment HistoryTimelineContainer_query on Query {\n  allHistories(condition: $condition, orderBy: CREATED_AT_DESC, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        createdAt\n        rowId\n        data\n        authorByAccomplishedBy {\n          name\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd41e0764ce49a536e79c9ee0cf38479";

export default node;
